import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { List } from 'immutable';
import { generatePath, withRouter } from 'react-router-dom';
import getIn from 'immutable-less/transmute/getIn';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PostMessageTypes from 'ui-addon-automation-embed/PostMessageTypes';
import { sendMessageToParent } from 'ui-addon-automation-embed/embedUtils';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import AppContext from 'automation-ui-core/context/AppContext';
import ListBranch from 'automation-ui-action-features/records/ListBranch';
import StaticBranch from 'automation-ui-action-features/records/StaticBranch';
import { getEmbedId, getSourceApp } from 'automation-ui-canvas/selectors/embedSelectors';
import * as messageActions from 'automation-ui-canvas/actions/MessageActions';
import { DISABLED_WITH_NO_ACTIONS, COPY_NOT_SUPPORTED } from 'automation-ui-canvas/constants/AlertTypes';
import Flow from 'automation-ui-canvas/flow/records/Flow';
import { getIsEnabled } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import EditDelayModal from 'automation-ui-action-features/components/delay/EditDelayModal';
import InsertOrRemoveBranchModal from 'automation-ui-canvas/components/modals/InsertOrRemoveBranchModal';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { CLASSIC_ANCHORED_DELAY, DELAY, LIST_BRANCH, STATIC_BRANCH, WAIT_UNTIL, AB_TEST_BRANCH } from 'automation-ui-action-features/constants/ActionTypes';
import { getIsEmbedded } from 'automation-ui-canvas/selectors/embedSelectors';
import { translateToGraph } from 'automation-ui-canvas/utils/platformWorkflowTranslators';
import { getAncestorEdges } from 'automation-ui-directed-graph/DirectedNodes';
import { ActionCardOptions } from 'automation-ui-canvas/components/action-card-options/constants/ActionCardOptions';
import { queryObjectsInActions } from 'automation-ui-canvas/action-features/objects-in-action/ObjectsInActionQueries';
import { sumChildObjectsInActionCount } from 'automation-ui-canvas/action-features/objects-in-action/objectsInActionUtils';
import { wireUpdateFlow, wireDeleteAction, defaultErrorHandlingForUpdateFlow } from 'automation-ui-canvas/queries/flowQueries';
import EditActionButton from 'automation-ui-canvas/components/action-card-options/EditActionButton';
import * as placements from 'automation-ui-canvas/components/canvas/copyPaste/placements';
import { copyActionToLocalStorage } from 'automation-ui-canvas/components/canvas/copyPaste/copyActionsToLocalStorage';
import { wirePasteActionModalConsumer } from 'automation-ui-canvas/components/canvas/copyPaste/PasteActionModalWrapper';
import { pasteActionInFlow } from 'automation-ui-canvas/components/canvas/copyPaste/pasteActionInFlow';
import { ACTION_SET_CONFIG, MOVE_CLONE_EDITOR } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import { buildSearchStringForActionSetRoutes } from 'automation-ui-canvas/utils/buildSearchStringForActionSetRoutes';
import { wireUnblockHistoryConsumer } from 'automation-ui-canvas/containers/hocs/UnblockHistoryContext';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { ACTION_SETS_V2 } from 'automation-ui-canvas/constants/Gates';
import { DuplicateIcon, MoveIcon, ClipboardIcon, DeleteIcon, GlobalGroupIcon } from 'foundations-assets';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class EditActionButtons extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showConfirmationModal: false,
      showConfirmationPopover: false,
      removeAllChildrenOnDelete: false,
      branchIndexToKeep: undefined
    };
    this.handleClickDeleteThisAction = () => {
      if (this.needConfirmationModal()) {
        this.setState({
          showConfirmationModal: true
        });
      } else {
        this.handleDeleteAction();
      }
    };
    this.handleCloseModal = () => this.setState({
      removeAllChildrenOnDelete: false,
      showConfirmationModal: false
    });
    this.handleClosePopover = () => this.setState({
      showConfirmationPopover: false
    });
    this.handleDeleteAction = () => {
      // This is to unblock the route block that's done when the panel form is dirty
      this.props.unblockHistory();
      const {
        isContextualEmbed
      } = this.context;
      const {
        action,
        deleteAction,
        embedId,
        flow,
        sourceApp,
        dispatch,
        updateFlow
      } = this.props;
      const {
        removeAllChildrenOnDelete,
        branchIndexToKeep
      } = this.state;
      const deleteCallback = response => {
        if (embedId && !isContextualEmbed) {
          sendMessageToParent({
            type: PostMessageTypes.REFRESH_SIDEPANEL_FLOW_DATA,
            embedId,
            flowId: flow.flowId
          });
        } else {
          const addAlertCallback = () => {
            if (isContextualEmbed) {
              // if we call to disable, we need to update the side panel after the update happens
              sendMessageToParent({
                type: PostMessageTypes.REFRESH_SIDEPANEL_FLOW_DATA,
                embedId,
                flowId: flow.flowId
              });
            }
          };
          // Add an alert if no actions remain and flow was disabled
          const addAlertSuccessCallback = () => {
            dispatch(messageActions.addAlert(DISABLED_WITH_NO_ACTIONS));
            addAlertCallback();
          };
          const disableFlow = flowResponse => {
            const newFlow = new Flow(flowResponse);
            return updateFlow({
              sourceApp,
              flow: newFlow.set('isEnabled', false)
            }).catch(error => {
              defaultErrorHandlingForUpdateFlow({
                error,
                dispatch
              });
              addAlertCallback();
            }).then(addAlertSuccessCallback);
          };
          const isEnabled = getIsEnabled(flow);
          const newActions = getIn(['actions'], response);
          if (isEnabled && newActions && Object.keys(newActions).length === 0) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            disableFlow(response);
          } else if (isContextualEmbed) {
            sendMessageToParent({
              type: PostMessageTypes.REFRESH_SIDEPANEL_FLOW_DATA,
              embedId,
              flowId: flow.flowId
            });
          }
        }
      };
      trackEvent(Trackables.CLICKED_ACTION_CARD_OPTION, {
        type: removeAllChildrenOnDelete ? ActionCardOptions.DELETE_ALL : ActionCardOptions.DELETE
      });
      // eslint-disable-next-line promise/catch-or-return,@typescript-eslint/no-floating-promises
      deleteAction({
        actionToDeleteId: action.getActionId(),
        flow,
        branchIndexToKeep,
        removeAllChildren: removeAllChildrenOnDelete,
        sourceApp
      }).then(deleteCallback);
    };
    this.needConfirmationModal = () => {
      const {
        flow,
        action,
        objectsInActions
      } = this.props;
      const {
        removeAllChildrenOnDelete
      } = this.state;
      const objectInAction = objectsInActions.find(objectAction => action.actionId === objectAction.actionId);
      let objectsInActionsCount = objectInAction ? objectInAction.count : 0;
      if (removeAllChildrenOnDelete && !objectsInActionsCount) {
        objectsInActionsCount = sumChildObjectsInActionCount({
          rootActionId: action.actionId,
          flow,
          objectsInActions
        });
      }
      switch (action.getActionType()) {
        case LIST_BRANCH:
        case STATIC_BRANCH:
        case AB_TEST_BRANCH:
          return !action.isLeafNode();
        default:
          return objectsInActionsCount > 0;
      }
    };
    this.handleMoveAction = ({
      cloneAction = false,
      moveAllChildren = false
    }) => () => {
      const operation = cloneAction ? ActionCardOptions.CLONE : ActionCardOptions.MOVE;
      const queryParams = {
        operation,
        moveAllChildren
      };
      let type = '';
      if (cloneAction) {
        type = moveAllChildren ? ActionCardOptions.CLONE_ALL : ActionCardOptions.CLONE;
      } else {
        type = moveAllChildren ? ActionCardOptions.MOVE_ALL : ActionCardOptions.MOVE;
      }
      trackEvent(Trackables.CLICKED_ACTION_CARD_OPTION, {
        type
      });
      this.redirectToMoveActionCanvas(queryParams);
    };
    this.redirectToMoveActionCanvas = queryParams => {
      const {
        flow,
        action,
        flowId,
        history,
        location
      } = this.props;
      const actionId = action.getActionId();
      const screen = getScreenForFlowType(flow.flowType);
      const pathname = generatePath(MOVE_CLONE_EDITOR, {
        flowId,
        screen,
        actionId
      });
      const search = buildSearchStringForActionSetRoutes(flow, location, queryParams);
      history.replace({
        pathname,
        search
      });
    };
    this.renderConfirmationModal = () => {
      const {
        action,
        flow,
        objectsInActions,
        flowObjectTypeId,
        getActionOutputsForTargetActionById
      } = this.props;
      const {
        removeAllChildrenOnDelete
      } = this.state;
      const objectsInAction = objectsInActions.find(objectAction => objectAction.actionId === action.actionId);
      const objectsInActionCount = objectsInAction ? objectsInAction.count : 0;
      let delayEnrollmentCount = objectsInActionCount;
      const areChildObjectsInAction = !objectsInActionCount && removeAllChildrenOnDelete;
      if (areChildObjectsInAction) {
        delayEnrollmentCount = sumChildObjectsInActionCount({
          rootActionId: action.actionId,
          objectsInActions,
          flow
        });
      }
      switch (action.getActionType()) {
        case LIST_BRANCH:
        case AB_TEST_BRANCH:
        case STATIC_BRANCH:
          {
            const connection = action.getConnection();
            const branches = connection.getBranches().size ? connection.getBranches() : action.isListBranch() ? List([new ListBranch()]) : List([new StaticBranch()]);
            return /*#__PURE__*/_jsx(InsertOrRemoveBranchModal, {
              action: action,
              hideDefaultBranch: action.getActionType() === AB_TEST_BRANCH,
              flowObjectTypeId: flowObjectTypeId,
              onSave: ({
                removeAllChildren,
                branchIndexToKeep
              }) => {
                this.setState({
                  showConfirmationModal: false,
                  removeAllChildrenOnDelete: removeAllChildren,
                  branchIndexToKeep
                }, this.handleDeleteAction);
              },
              getActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
              onClose: this.handleCloseModal,
              stagedChanges: {
                branches,
                defaultBranchName: connection.getDefaultBranchName()
              },
              langKeyPath: "edit.removeBranchModal"
            });
          }
        case DELAY:
        case WAIT_UNTIL:
          return /*#__PURE__*/_jsx(EditDelayModal, {
            onConfirm: () => {
              this.setState({
                showConfirmationModal: false
              });
              this.handleDeleteAction();
            },
            onDismiss: this.handleCloseModal,
            areChildObjectsInAction: areChildObjectsInAction,
            isDeleting: true,
            delayEnrollmentCount: delayEnrollmentCount,
            flowObjectTypeId: flowObjectTypeId,
            isDelayActionType: true,
            isIncreasing: false,
            isDecreasing: false
          });
        default:
          return /*#__PURE__*/_jsx(EditDelayModal, {
            onConfirm: () => {
              this.setState({
                showConfirmationModal: false
              });
              this.handleDeleteAction();
            },
            onDismiss: this.handleCloseModal,
            areChildObjectsInAction: areChildObjectsInAction,
            isDeleting: true,
            delayEnrollmentCount: delayEnrollmentCount,
            flowObjectTypeId: flowObjectTypeId,
            isDelayActionType: false,
            isIncreasing: false,
            isDecreasing: false
          });
      }
    };
  }
  getCopyPasteOptions() {
    const {
      action,
      flow,
      flowObjectTypeId,
      flowId,
      dispatch,
      isEmbedded
    } = this.props;
    if (isEmbedded) {
      return [];
    }
    if (action.getActionType() === CLASSIC_ANCHORED_DELAY) {
      if (flow.getFirstActionId() === action.getActionId()) {
        return [{
          label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "automation.common.editActionDropdown.paste.after"
          }),
          onClick: () => {
            this.handleClickPaste(placements.AFTER);
          }
        }];
      }
      return [{
        label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation.common.editActionDropdown.paste.before"
        }),
        onClick: () => {
          this.handleClickPaste(placements.BEFORE);
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation.common.editActionDropdown.paste.after"
        }),
        onClick: () => {
          this.handleClickPaste(placements.AFTER);
        }
      }];
    }
    return [{
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.copy"
      }),
      onClick: () => {
        trackEvent(Trackables.CLICKED_COPY_ACTION, {
          actionType: action.getActionType()
        });
        try {
          copyActionToLocalStorage({
            action,
            flowObjectTypeId,
            flowId
          });
        } catch (error) {
          dispatch(messageActions.addAlert(COPY_NOT_SUPPORTED));
        }
      }
    }, {
      label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "automation.common.editActionDropdown.paste.before"
      }),
      onClick: () => {
        this.handleClickPaste(placements.BEFORE);
      }
    }, {
      label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "automation.common.editActionDropdown.paste.after"
      }),
      onClick: () => {
        this.handleClickPaste(placements.AFTER);
      }
    }];
  }
  getMoveAndCloneOptions() {
    const {
      action,
      flow,
      isEmbedded,
      onlyShowDelete
    } = this.props;
    const {
      isContextualEmbed
    } = this.context;
    if (onlyShowDelete || isContextualEmbed || isEmbedded) {
      return [[], []];
    }
    const actionType = action.getActionType();
    const cloneSingleActionOption = {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.cloneAction.thisAction"
      }),
      onClick: this.handleMoveAction({
        cloneAction: true,
        moveAllChildren: false
      })
    };
    const cloneAllActionsOption = {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.cloneAction.allActions"
      }),
      onClick: this.handleMoveAction({
        cloneAction: true,
        moveAllChildren: true
      })
    };
    const moveSingleActionOption = {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.moveAction.thisAction"
      }),
      onClick: this.handleMoveAction({
        moveAllChildren: false
      })
    };
    const moveAllActionsOption = {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.moveAction.allActions"
      }),
      onClick: this.handleMoveAction({
        moveAllChildren: true
      })
    };
    if (flow.getActions().size <= 1) {
      moveSingleActionOption.disabled = true;
      moveSingleActionOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableOnlyOneAction"
      });
      moveAllActionsOption.disabled = true;
      moveAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableOnlyOneAction"
      });
    }

    // CLASSIC_ANCHORED_DELAY actions - which only appear in date-based
    // workflows - must execute in chronological order by their specified dates.
    if (actionType === CLASSIC_ANCHORED_DELAY) {
      cloneSingleActionOption.disabled = true;
      cloneSingleActionOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableForActionType.clone"
      });
      cloneAllActionsOption.disabled = true;
      cloneAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableForActionType.clone"
      });
      moveSingleActionOption.disabled = true;
      moveSingleActionOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableForActionType.move"
      });
      moveAllActionsOption.disabled = true;
      moveAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableForActionType.move"
      });
    }

    // Moving a branch action without its descendants is not yet supported
    if (action.isBranch()) {
      moveSingleActionOption.disabled = true;
      moveSingleActionOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.cannotMoveBranchActionAlone"
      });
    }
    const graph = translateToGraph(flow, true);
    const ancestorEdges = getAncestorEdges(action.getActionId(), graph.getEdges());
    const isDescendentOfABranchAction = ancestorEdges.some(edge => {
      const ancestorAction = flow.getActionById(edge.getFromNode());
      return ancestorAction && ancestorAction.isBranch();
    });
    if (!isDescendentOfABranchAction) {
      moveAllActionsOption.disabled = true;
      moveAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.noBranchesToMoveTo"
      });
    }

    // Because the move and clone all actions operations doesn't account for the
    // ordering of CLASSIC_ANCHORED_DELAY actions, we disable it for all actions
    // in date-based workflows.
    if (flow.getClassicEventAnchor()) {
      cloneAllActionsOption.disabled = true;
      cloneAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableInDateBasedFlow"
      });
      moveAllActionsOption.disabled = true;
      moveAllActionsOption.tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.notAvailableInDateBasedFlow"
      });
    }
    let cloneOptions = [cloneSingleActionOption, cloneAllActionsOption].filter(option => !option.disabled);
    let moveOptions = [moveSingleActionOption, moveAllActionsOption].filter(option => !option.disabled);

    // If all options are disabled, show a disabled button using the all actions option's tooltip
    if (cloneOptions.length === 0) {
      cloneOptions = [cloneAllActionsOption];
    }
    if (moveOptions.length === 0) {
      moveOptions = [moveAllActionsOption];
    }
    return [cloneOptions, moveOptions];
  }
  getDeleteOptions() {
    const {
      flow,
      action
    } = this.props;
    const actionId = action.getActionId();
    const isAnchoredDelayAction = action.getActionType() === CLASSIC_ANCHORED_DELAY;
    const isFirstAction = flow.getFirstActionId() === actionId;
    const hideDelete = isFirstAction && isAnchoredDelayAction;
    if (hideDelete) {
      return [];
    }
    const deleteSingleActionOption = {
      'data-test-id': `edit-action-dropdown-delete-one-${actionId}`,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.deleteAction.thisAction"
      }),
      onClick: this.handleClickDeleteThisAction
    };
    const deleteAllActionsOption = {
      'data-test-id': `edit-action-dropdown-delete-multi-${actionId}`,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.deleteAction.allActions"
      }),
      onClick: () => this.setState({
        showConfirmationPopover: true
      })
    };
    if (action.isBranch()) {
      return [deleteSingleActionOption];
    } else {
      return [deleteSingleActionOption, deleteAllActionsOption];
    }
  }
  getActionSetOptions() {
    const {
      action,
      flowId,
      history,
      isUngated
    } = this.props;
    const actionSetId = action.getParentActionSetId();
    if (actionSetId && isUngated(ACTION_SETS_V2)) {
      return [{
        label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation.common.editActionDropdown.actionSet"
        }),
        onClick: () => history.replace({
          pathname: generatePath(ACTION_SET_CONFIG, {
            flowId,
            actionSetId
          })
        })
      }];
    }
    return [];
  }
  handleClickPaste(placement) {
    const {
      action,
      flow,
      updateFlow,
      showPasteActionModal,
      setPastingData,
      showLoadingOverlay,
      dispatch
    } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    pasteActionInFlow({
      action,
      flow,
      placement,
      showLoadingOverlay: showLoadingOverlay,
      setPastingData,
      showPasteActionModal,
      updateFlow,
      dispatch
    });
  }

  /**
   * Under certain conditions, deleting an action
   * requires extra steps. This function includes
   * cases for specific actions that will trigger
   * rendering of a modal.
   *
   * Note that if we are removing all children,
   * it's likely we'll want to ignore this check.
   */

  render() {
    const {
      isEmbedded,
      action
    } = this.props;
    const {
      showConfirmationModal,
      showConfirmationPopover
    } = this.state;
    const [cloneOptions, moveOptions] = this.getMoveAndCloneOptions();
    const deleteOptions = this.getDeleteOptions();
    const actionSetOptions = this.getActionSetOptions();

    // UIList won't apply firstChildClassName correctly if the first child is a nullish value
    const buttons = [];
    if (cloneOptions.length > 0) {
      buttons.push( /*#__PURE__*/_jsx(EditActionButton, {
        IconAsset: DuplicateIcon,
        defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.editActionDropdown.clone"
        }),
        options: cloneOptions,
        "data-test-id": `edit-action-button-clone-${action.getActionId()}`
      }, "clone"));
    }
    if (moveOptions.length > 0) {
      buttons.push( /*#__PURE__*/_jsx(EditActionButton, {
        IconAsset: MoveIcon,
        defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.editActionDropdown.move"
        }),
        options: moveOptions,
        "data-test-id": `edit-action-button-move-${action.getActionId()}`
      }, "move"));
    }
    if (!isEmbedded) {
      buttons.push( /*#__PURE__*/_jsx(EditActionButton, {
        IconAsset: ClipboardIcon,
        defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.editActionDropdown.copyPaste"
        }),
        options: this.getCopyPasteOptions(),
        "data-test-id": `edit-action-button-copy-paste-${action.getActionId()}`
      }, "copyPaste"));
    }
    if (deleteOptions.length > 0) {
      buttons.push( /*#__PURE__*/_jsx(Popover, {
        open: showConfirmationPopover,
        onOpenChange: event => this.setState({
          showConfirmationPopover: event.target.value
        }),
        content: {
          header: /*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.common.editActionDropdown.confirmationPopover.body"
            })
          }),
          footer: /*#__PURE__*/_jsxs(UIButtonWrapper, {
            children: [/*#__PURE__*/_jsx(UIButton, {
              "data-test-id": "delete-actions-popover-confirm-button",
              onClick: () => {
                this.handleClosePopover();
                this.setState({
                  removeAllChildrenOnDelete: true
                }, this.handleClickDeleteThisAction);
              },
              use: "danger",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.common.editActionDropdown.confirmationPopover.delete"
              })
            }), /*#__PURE__*/_jsx(UIButton, {
              onClick: this.handleClosePopover,
              use: "tertiary-light",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.common.editActionDropdown.confirmationPopover.cancel"
              })
            })]
          })
        },
        children: /*#__PURE__*/_jsx(EditActionButton, {
          IconAsset: DeleteIcon,
          defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.editActionDropdown.delete"
          }),
          options: deleteOptions,
          "data-test-id": `edit-action-button-delete-${action.getActionId()}`
        })
      }, "delete"));
    }
    if (actionSetOptions.length > 0) {
      buttons.push( /*#__PURE__*/_jsx(EditActionButton, {
        IconAsset: GlobalGroupIcon,
        defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.editRecordAction.actionSet"
        }),
        options: actionSetOptions,
        "data-test-id": `edit-action-button-actionset-${action.getActionId()}`
      }, "actionSet"));
    }
    return /*#__PURE__*/_jsxs("div", {
      onClick: event => event.stopPropagation(),
      children: [/*#__PURE__*/_jsx(Flex, {
        gap: "200",
        children: buttons
      }), showConfirmationModal && this.renderConfirmationModal()]
    });
  }
}
EditActionButtons.contextType = AppContext;
EditActionButtons.defaultProps = {
  showLoadingOverlay: () => {}
};
const mapStateToProps = state => ({
  embedId: getEmbedId(state),
  isEmbedded: getIsEmbedded(state),
  sourceApp: getSourceApp(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default compose(withRouter, WrappedComponent => props => {
  const {
    flowId
  } = props;
  return queryObjectsInActions(WrappedComponent, Number(flowId))(props);
}, connect(mapStateToProps, mapDispatchToProps), wireUpdateFlow, wireDeleteAction, wirePasteActionModalConsumer, wireUnblockHistoryConsumer, wireAuthConsumer)(EditActionButtons);